module.exports = __webpack_public_path__ + "assets/ce2fe22da3e12b01cfac6e2e73c28716.mp3";